const initState = {}

export function upload(state = initState, action) {
  switch (action.type) {
    default:
      return state
  }
}
